import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShieldCheckIcon, CreditCardIcon, LockKeyholeIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function Services() {
  return <div className="w-full min-h-screen bg-white" data-id="element-250">
      <div className="max-w-6xl mx-auto px-6 py-12" data-id="element-251">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 font-medium transition-colors" data-id="element-252">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-253" />
          Back to Home
        </Link>
        <div className="text-center mb-16" data-id="element-254">
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-255">
            Enhanced Payment Protection
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-256">
            Multi-layered security designed to keep your payments safe and your
            data protected
          </p>
        </div>
        <div className="space-y-8" data-id="element-257">
          {/* PCI Certified Payment Page */}
          <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-200" data-id="element-258">
            <div className="flex items-start gap-6" data-id="element-259">
              <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0" data-id="element-260">
                <ShieldCheckIcon className="w-7 h-7 text-white" data-id="element-261" />
              </div>
              <div className="flex-1" data-id="element-262">
                <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-263">
                  PCI Certified Payment Portal
                </h2>
                <p className="text-lg text-slate-700 mb-4 leading-relaxed" data-id="element-264">
                  Experience peace of mind with our industry-leading payment
                  infrastructure. Our platform undergoes rigorous external
                  certification under PCI DSS standards annually, ensuring your
                  payment data is handled with the highest level of security.
                </p>
                <div className="bg-white border border-slate-200 rounded-xl p-6" data-id="element-265">
                  <h3 className="font-semibold text-slate-900 mb-3" data-id="element-266">
                    Complete Coverage
                  </h3>
                  <p className="text-slate-700" data-id="element-267">
                    Every payment method on our portal—from credit cards to
                    digital wallets—benefits from the same robust security
                    standards. No matter how you choose to pay, your transaction
                    is protected by enterprise-grade encryption and compliance.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Latest 3DS Security */}
          <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-200" data-id="element-268">
            <div className="flex items-start gap-6" data-id="element-269">
              <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0" data-id="element-270">
                <LockKeyholeIcon className="w-7 h-7 text-white" data-id="element-271" />
              </div>
              <div className="flex-1" data-id="element-272">
                <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-273">
                  Advanced 3D Secure Authentication
                </h2>
                <p className="text-lg text-slate-700 mb-4 leading-relaxed" data-id="element-274">
                  Stay ahead of fraud with cutting-edge authentication
                  technology. Our Enhanced Payment Protection leverages the
                  latest 3D Secure protocols, providing an additional layer of
                  verification that adapts to each transaction's risk level.
                </p>
                <div className="bg-white border border-slate-200 rounded-xl p-6" data-id="element-275">
                  <h3 className="font-semibold text-slate-900 mb-3" data-id="element-276">
                    Maximum Protection
                  </h3>
                  <p className="text-slate-700" data-id="element-277">
                    Every eligible transaction is automatically protected by
                    state-of-the-art authentication protocols. This means
                    stronger security without compromising your checkout
                    experience—keeping both you and your customers safe from
                    unauthorized transactions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Single Use Card */}
          <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-200" data-id="element-278">
            <div className="flex items-start gap-6" data-id="element-279">
              <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0" data-id="element-280">
                <CreditCardIcon className="w-7 h-7 text-white" data-id="element-281" />
              </div>
              <div className="flex-1" data-id="element-282">
                <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-283">
                  Single-Use Virtual Cards
                </h2>
                <p className="text-lg text-slate-700 mb-4 leading-relaxed" data-id="element-284">
                  Revolutionary card protection that keeps your real payment
                  details completely private. Each transaction is processed
                  through a unique, single-use virtual Mastercard, creating an
                  impenetrable barrier between your sensitive information and
                  merchants.
                </p>
                <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4" data-id="element-285">
                  <div data-id="element-286">
                    <h3 className="font-semibold text-slate-900 mb-2" data-id="element-287">
                      How It Works
                    </h3>
                    <p className="text-slate-700" data-id="element-288">
                      When you make a purchase, we instantly generate a secure
                      virtual Mastercard specifically for that transaction.
                      Merchants process payments using this virtual card, never
                      seeing or storing your actual card details.
                    </p>
                  </div>
                  <div data-id="element-289">
                    <h3 className="font-semibold text-slate-900 mb-2" data-id="element-290">
                      Ultimate Privacy
                    </h3>
                    <p className="text-slate-700" data-id="element-291">
                      Your original payment method remains completely hidden and
                      protected. This eliminates the risk of data breaches,
                      unauthorized charges, and identity theft—giving you total
                      control and peace of mind with every transaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-292">
          <div className="bg-slate-900 rounded-3xl p-12 text-white" data-id="element-293">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight" data-id="element-294">
              Ready to Experience Enhanced Protection?
            </h2>
            <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-295">
              Join thousands of customers who trust Pomelo Services for secure,
              seamless payment protection
            </p>
            <a href="mailto:enquiries@pomeloservices.uk" className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-all duration-200 shadow-lg shadow-blue-600/20" data-id="element-296">
              Get Started Today
            </a>
          </div>
        </div>
      </div>
      <Footer data-id="element-297" />
    </div>;
}